export default {
  calibrationHomepageMessage: state => state.calibrationHomepageMessage

}



// WEBPACK FOOTER //
// ./src/store/modules/notificationmessage/getters.js